<template>
  <div class="myAddr">
    <div class="addrBox" >
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="myReceiveList"
      >
        <div class="item" v-for="(item,index) in addrList" :key="index">
          <div class="userAddr" @click="selAddr(item.id)">
            <div class="top">
              <span class="name">{{ item.receive_name }}</span>
              <span class="tel">{{  item.receive_tel }}</span>
            </div>
            <span class="address">{{   item.address_path_title | pcaFilter }} {{ item.receive_address  }} </span>
          </div>
          <div class="editBox">
            <div class="is_default" v-if="item.is_default == 1">
              <img src="../../assets/my/address.png" />
              <span>默认地址</span>
            </div>
              <router-link tag="div" :to="{name:'editAddress',query:{id:item.id,receive_name:item.receive_name,receive_tel:item.receive_tel,address_title:item.address_path_title,receive_address:item.receive_address,is_default:item.is_default}}"  class="edit"  @click="edit(item.id)">
                <img src="../../assets/my/edit.png" />
                <span>编辑</span>
              </router-link>
          </div>
        </div>
      
      
      </van-list>

      <!-- <div v-if="!list.length" style="padding-top:200px;color:#999;text-align:center;font-size:18px;">暂无数据</div> -->

      



    </div>
    <router-link tag="div" to="addAddr" class="btn">新建地址</router-link>
  </div>
</template>
<style lang="less" scoped>
.myAddr {
  width: 100%;
  padding: 0 0 30px;
  box-sizing: border-box;
  // background-color: #fff;
  .item {
    width: 100%;
    box-sizing: border-box;
    padding: 10px 24px;
    background-color: #fff;
    border-bottom: 20px solid #e4e4e4;
    .userAddr {
      display: flex;
      flex-direction: column;
      padding-bottom: 30px;
      border-bottom: 1px solid #eee;
      .top {
        display: flex;
        align-items: center;
        margin-bottom: 24px;
        span {
          font-size: 30px;
          color: #333;
          margin-right: 30px;
        }
      }
      .address {
        font-size: 28px;
        color: #666;
        line-height: 44px;
      }
    }
    .editBox {
      display: flex;
      align-items: center;
      height: 110px;
      .is_default {
        display: flex;
        align-items: center;
        font-size: 28px;
        color: #e42129;
        img {
          width: 30px;
          margin-right: 10px;
        }
      }
      .edit {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        font-size: 28px;
        color: #666;
        img {
          width: 43px;
          margin-right: 10px;
        }
      }
    }
  }
  .btn {
    width: 100%;
    height: 110px;
    background-color: #e42129;
    color: #fff;
    font-size: 32px;
    line-height: 100px;
    text-align: center;
    position: fixed;
    left: 0;
    bottom: 0;
    z-index: 10;
  }
}
</style>

<script>
export default {
  data() {
    return {
      addrList: [],
      toPage: null,
      page: 1,
      is_sel:0,
      loading:false,
      finished: false,
    };
  },
  computed: {},
  created() {
    if(this.$route.query.is_sel == 1){
      this.is_sel = 1
    }
    // this.myReceiveList();
  },
  methods: {
    // 获取地址列表
    myReceiveList() {
      this.$http({
        url: "myReceiveList",
        data: {
          page: this.page
        }
      }).then(res => {
        this.loading = false

        this.page = this.page+1
        
        this.addrList = this.addrList.concat(res._list);

        // if(!this.addrList.length && this.is_sel == 1 && !this.$store.state.addr_flag) {
          
        //   this.$router.push({name:'addAddress'})
        //   this.$store.commit('changeAddr_flag',true)

        // }

        if(!res._list.length) return this.finished = true
        

      });
    },
    selAddr(id){
      if(this.is_sel != 1) return

      let addrList = this.addrList
      
      let [addr] = addrList.filter(item=>item.id == id)
      
      this.$store.commit('setSelAddr',addr)

      this.$router.go(-1)
      
    },
    onScroll(e) {
    


    },
  },
  beforeRouteUpdate(to, from, next) {
    if (!this.toPage) this.toPage = to.name;
    if (from.name == this.toPage) {
      this.page = 1;
      this.myReceiveList();
    }
    next();
  }
};
</script>
